import { ApiBase } from "config";
import api from "utils/api";
import { AsyncOption, IDropdownModel } from "common/models/IDropdownModel";

const dropdownUrl = `${ApiBase}/api/dropdown`;

// function getProgramByInstitute(instituteID: number) {
//   return api.get<IDropdownModel[]>(`${dropdownUrl}/getProgram/${instituteID}`);
// }

function getProgrambyCommunity() {
  return api.get<IDropdownModel[]>(`${dropdownUrl}/getProgrambyCommunity`);
}

function getBatchByProgramID(programID: number) {
  return api.get<IDropdownModel[]>(
    `${dropdownUrl}/getBatchByProgramID/${programID}`
  );
}

function getSkills(inputValue: string | null, id: string | null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getAutoCompleteSkill`, {
    name: inputValue,
    id: id,
  });
}

function getIndustries(value: string | null, id: string | null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getAutoCompleteIndustry`, {
    name: value,
    id: id,
  });
}

function getInstitutes(inputValue: string | null, id: string | null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getAutoCompleteInstitute`, {
    name: inputValue,
    id: id,
  });
}

function getPrograms(inputValue: string | null, id: string | null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getAutoCompleteProgram`, {
    name: inputValue,
    id: id,
  });
}

function getHigherEducationInstitutes(inputValue: string | null, id: string | null = null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getAutoCompleteHigherEducationInstitute`, {
    label: inputValue,
    value: id,
    name: inputValue,
    id: id,
  });
}

function getHigherEducationCourses(inputValue: string | null, id: string | null = null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getAutoCompleteHigherEducationCourse`, {
    label: inputValue,
    value: id,
    name: inputValue,
    id: id,
  });
}

function getHigherEducationSpecializations(inputValue: string | null, id: string | null = null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getAutoCompleteHigherEducationSpecialization`, {
    label: inputValue,
    value: id,
    name: inputValue,
    id: id,
  });
}

export default {
  getProgrambyCommunity,
  getBatchByProgramID,
  getSkills,
  getIndustries,
  getInstitutes,
  getPrograms,
  getHigherEducationInstitutes,
  getHigherEducationCourses,
  getHigherEducationSpecializations,
};

